export var getLocale = function getLocale() {
  var language = navigator.language.split('-');

  if (language[0] === 'pt') {
    return 'pt-BR';
  }

  if (language.length === 2) {
    return "".concat(language[0], "-").concat(language[1].toUpperCase());
  }

  return navigator.language;
}; // 本地静态常量涉及多语言时，可以用这个

export var getStaticLocale = function getStaticLocale() {
  return navigator.language.split('-')[0];
};